import React, { useEffect } from "react";
import { FaUser, FaLock, FaCalendarAlt, FaShieldAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const ProfileDropdown = ({
    showDesktopProfileMenu,
    setShowDesktopProfileMenu,
    main,
    profiledropdownRef
}) => {
    const navigate = useNavigate();
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (profiledropdownRef.current && !profiledropdownRef.current.contains(event.target)) {
                setShowDesktopProfileMenu(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [setShowDesktopProfileMenu]);

    return (
        <div
            className={`profile-dropdown-wrapper ${showDesktopProfileMenu ? 'show' : ''}`}
        >
            <div className={`profile-dropdown-dropdown ${showDesktopProfileMenu ? 'active' : ''}`}>
                <div className="profile-sidebar-header">
                    <span>Welcome</span>
                    <h5>{main?.user?.first_name} {main?.user?.last_name}</h5>
                </div>
                <div className="profile-dropdown-list space-y-3">
                    <div className="flex align-items-center gap-3 cursor-pointer" onClick={() => navigate("/personal-data")}>
                        <a className="text-sm text-gray-800"><FaUser size={25} style={{ marginRight: "10px" }} /> Personal Data</a>
                    </div>

                    <div className="flex align-items-center gap-3 cursor-pointer" onClick={() => navigate("/passwords")}>
                        <a className="text-sm text-gray-800"><FaLock size={25} style={{ marginRight: "10px" }} /> Passwords</a>
                    </div>

                    <div className="flex align-items-center gap-3 cursor-pointer" onClick={() => navigate("/calendar-appointments")}>
                        <a className="text-sm text-gray-800"><FaCalendarAlt size={25} style={{ marginRight: "10px" }} /> My Calendar</a>
                    </div>

                    <div className="flex align-items-center gap-3 cursor-pointer" onClick={() => navigate("/privacy-and-consent")}>
                        <a className="text-sm text-gray-800"><FaShieldAlt size={25} style={{ marginRight: "10px" }} /> Privacy and Consent</a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfileDropdown